export const CreateProductRoutes = {
  createProduct: "/admin/create-product",
  getAllProduct: "/admin/get-products",
  deleteProduct: "/admin/delete-product/",
  getDetailedProductinfo: "/admin/get-product-detail/",
  updateProduct: "/admin/update-product/",
  getProductById: "/admin/get-product-detail/",
};
